"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxTabsList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const InfoBoxTabItem_1 = require("../InfoBoxTabItem");
const infobox_1 = require("../../utils/infobox");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const useInfoBoxTabsOrder_1 = require("../../hooks/useInfoBoxTabsOrder");
const TABS_DICT = i18n_1.Strings.infoBox.tabs;
function InfoBoxTabsList({ className }) {
    const infoBoxTabOrder = (0, useInfoBoxTabsOrder_1.useInfoBoxTabsOrder)();
    const items = infoBoxTabOrder
        .map(type => (Object.assign(Object.assign({}, infobox_1.INFOBOX_TABS[type]), { type })))
        .map(({ type, icon = ui_1.Icons.Info, key }, i) => ((0, jsx_runtime_1.jsx)(InfoBoxTabItem_1.InfoBoxTabItem, { icon: icon, label: key ? (0, i18n_1.Localized)(TABS_DICT[key]) : bridge_schema_1.InfoBoxTabType[type], index: i, focusable: false, "data-e2e": 'InfoBoxTabsList_InfoBoxTabItem' }, key)));
    return (0, jsx_runtime_1.jsx)(StyledScrollView, { className: className, "data-e2e": 'InfoBoxTabsList_StyledScrollView', children: items });
}
exports.InfoBoxTabsList = InfoBoxTabsList;
const StyledScrollView = (0, styled_components_1.default)(ui_1.SimpleScrollView) `
  box-sizing: border-box;

  width: 100%;
  overflow-y: hidden;
`;
